import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";

export type SearchResponse = {
  id: number;
  title: string;
  description: string;
  type: string;
};

export const searchApi = createApi({
  reducerPath: "searchApi",
  baseQuery: baseAuthQuery("search"),
  tagTypes: ["Search"],
  endpoints: (builder) => ({
    search: builder.query<ApiResponse<Record<string, SearchResponse[]>>, { query: string }>({
      query: ({ query }) => ({
        url: "",
        method: "GET",
        params: { query },
      }),
      providesTags: (result, error, q) => {
        return [{ type: "Search", id: q.query }];
      },
    }),
  }),
});
